// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/@nuxt/webpack/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".footer[data-v-0be0f8d9]{z-index:500;background-color:#f8f8f8;position:fixed;bottom:0;left:0;right:0;text-align:center;padding-top:.5rem}.footer__above[data-v-0be0f8d9]{font-size:1.2rem;margin-bottom:.5rem}.footer__above--italic[data-v-0be0f8d9]{font-style:italic}.footer__background[data-v-0be0f8d9]{color:#fff;padding:1rem}.footer__loader[data-v-0be0f8d9]{position:absolute;right:1.5rem;bottom:1.5rem}", ""]);
// Exports
module.exports = exports;
